<template>
  <div :id="galleryID">
    <div v-for="(image, key) in imagesData"
         class="chat-widget__gallery-item"
         :key="key">
      <a

          :href="image.url"
          :data-pswp-width="image.width"
          :data-pswp-height="image.height"
          target="_blank"
          rel="noreferrer"
      >
        <img style="width: 100%" :src="image.url" alt=""/>
      </a>

      <div class="chat-widget__gallery-item--buttons" >
        <Button severity="secondary" type="button" icon="pi pi-palette"
                label="На основе"
                :disabled="appStore.blockSending"
                v-tooltip.bottom="regenerateTooltip"
                @click="(e) => createVariation(messageId, image.url)"
                v-if="useAppStateStore().features.imageVariation && useAppStateStore().authorized"/>

        <Button severity="secondary" type="button" icon="pi pi-download"
                label=""
                v-tooltip.bottom="'Скачать'"
                @click="(e) => downloadFile(image.url, image.filename)"
                v-if="image.url"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, onMounted, onUnmounted, toRefs} from 'vue';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import Button from 'primevue/button';
import {downloadFile} from "@/services/helper";
import {useAppStateStore} from "@/modules/chat/stores/appStore";
import {useChatStore} from "@/modules/chat/stores/chatStore";

// Props are directly accessible in the <script setup>
const props = defineProps({
  galleryID: String,
  images: Array,
  messageId: {
    type: String,
    required: true
  }
});

// Using toRefs to create a reactive reference to props
const {images} = toRefs(props);

let lightbox;

onMounted(() => {
  lightbox = new PhotoSwipeLightbox({
    gallery: `#${props.galleryID}`,
    children: 'a',
    pswpModule: () => import('photoswipe'),
  });
  lightbox.init();
});

onUnmounted(() => {
  if (lightbox) {
    lightbox.destroy();
    lightbox = null;
  }
});

const createVariation = async (messageId, url) => {
  await useChatStore().imageVariation(messageId, url);
};

const appStore = useAppStateStore();

const regenerateTooltip = computed(() => appStore.blockSending ? 'Дождитесь завершения предыдущего запроса' : 'Создать на основе этого изображения');

// Exposing imagesData for template
const imagesData = images;
</script>
